import axios from "axios";
import router from "@/router";

const instance = axios.create({
    baseURL: process.env.VUE_APP_API,
    withCredentials: true,
    withXSRFToken: true
});

instance.interceptors.request.use(
    (config) => {
        const authToken = localStorage.getItem("authToken");

        console.log('authToken:', authToken);

        if (authToken) {
            config.headers["Authorization"] = `Bearer ${authToken}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.status === 401) {
            localStorage.setItem("isAuthenticated", false.toString());
            if (router.currentRoute.name != 'Home') {
                router.push({ name: 'Home' });
            }
        }
        // if (error.response.status === 403) {
        //     localStorage.setItem('emailVerified', false.toString());
        //     router.push({ name: "EmailVerificationNotice" });
        // }
        return Promise.reject(error);
    }
);

export default instance;